export default "__VITE_ASSET__dd348704__"